export default {
  //DataTable
  "DataTable.body.noMatch": "Sorry, no matching records found",
  "DataTable.body.toolTip": "Sort",
  "DataTable.body.columnHeaderTooltip": "Sort for {column}",
  "DataTable.pagination.next": "Next Page",
  "DataTable.pagination.previous": "Previous Page",
  "DataTable.pagination.rowsPerPage": "Rows per page:",
  "DataTable.pagination.displayRows": "{from} - {to} of {count}",
  "DataTable.toolbar.search": "Search",
  "DataTable.toolbar.downloadCsv": "Download CSV",
  "DataTable.toolbar.print": "Print",
  "DataTable.toolbar.viewColumns": "View Columns",
  "DataTable.toolbar.filterTable": "Filter Table",
  "DataTable.filter.all": "All",
  "DataTable.filter.title": "FILTERS",
  "DataTable.filter.reset": "RESET",
  "DataTable.viewColumns.title": "Show Columns",
  "DataTable.viewColumns.titleAria": "Show/Hide Table Columns",
  "DataTable.selectedRows.text": "row(s) selected",
  "DataTable.selectedRows.delete": "Delete",
  "DataTable.selectedRows.deleteAria": "Delete Selected Rows",

  //Dialog
  "Dialog.btn.ok" : "OK",
  "Dialog.btn.cancel": "CANCEL",
  "Dialog.btn.close": "CLOSE",

  //FileSelect
  "FileSelect.err.typepermission": "File type not allowed",
  "FileSelect.err.sizeover": "File size exceeds maximum",
  "FileSelect.err.title": "Error",
  
  //Header
  "Header.MenuBar.logout": "Logout",
  
  //TimeCheck
  "TimeCheck.err.timeout": "Session Timeout { value }",
  "TimeCheck.btn.close": "CLOSE",
  
  //validate
  "validate.required": "Required fields",
  
};
